<h1 aria-hidden="true" class="p-0 m-0 text-white ds-heading--s" data-cy="dynamic-heading">{{heading || (title$ | async)}}</h1>
